var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ml-1" },
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "button",
              {
                on: {
                  click: _vm.showModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("TagIcon", { staticClass: "w-4 h-5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("EditIconHover", { staticClass: "w-4 h-5" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        { showModal: _vm.showModal }
      ),
      _vm.modalShown
        ? _c("ClientEditModal", {
            attrs: {
              dialog: _vm.modalShown,
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
              activeTab: _vm.activeTab,
              isCareplanExist: _vm.isCareplanExist,
              initialData: _vm.initialProject,
              isEdit: true,
              currentEditTab: _vm.currentEditTab,
            },
            on: { closeDialog: _vm.hanldeCancel, close: _vm.handleClose },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }